import { createTheme } from '@material-ui/core/styles'

export const themeDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        padding: 0,
        color: '#000',
      },
      elevation1: {
        boxShadow: 'none',
      },
    },
    MuiCard: {
      root: {
        overflow: 'initial',
        marginBottom: '0 !important',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
    MuiGrid: {
      root: {
        width: '100%',
        '& [class*="MuiGrid-container-"]': {
          flexDirection: 'row !important',
        },
        '& [class*="MuiGrid-item-"]': {
          width: '100%',
          display: 'contents',
        },
      },
      item: {
        width: '100%',
        display: 'contents',
      },
      container: {
        flexDirection: 'row !important',
      },
    },
  },
})

export const dashboardDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        height: '100%',
        padding: '0',
        backgroundColor: 'transparent',
      },
      elevation1: {
        boxShadow: 'none',
      },
    },
    MuiCard: {
      root: {
        overflow: 'initial',
        marginBottom: '0 !important',
        boxShadow: 'unset !important',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
    MuiGrid: {
      root: {
        width: '100%',
        '& [class*="MuiGrid-direction-"]': {
          flexDirection: 'row !important',
        },
        '& [class*="MuiGrid-container-"]': {
          flexDirection: 'row !important',
        },
        '& [class*="MuiGrid-item-"]': {
          width: '100%',
          display: 'contents',
        },
      },
      item: {
        width: '100%',
        display: 'contents',
      },
      container: {
        justifyContent: 'center',
      },
    },
  },
})
